import React from 'react';

const COLOR_MAP = {
  blue:   { bg: '#eff6ff', border: '#bfdbfe', icon: '#2563eb', title: '#1e40af', value: '#1e40af' },
  green:  { bg: '#f0fdf4', border: '#bbf7d0', icon: '#16a34a', title: '#166534', value: '#15803d' },
  purple: { bg: '#faf5ff', border: '#e9d5ff', icon: '#9333ea', title: '#6b21a8', value: '#7e22ce' },
  orange: { bg: '#fff7ed', border: '#fed7aa', icon: '#ea580c', title: '#9a3412', value: '#c2410c' },
  red:    { bg: '#fef2f2', border: '#fecaca', icon: '#dc2626', title: '#991b1b', value: '#b91c1c' },
  yellow: { bg: '#fefce8', border: '#fde68a', icon: '#ca8a04', title: '#854d0e', value: '#a16207' },
};

export default function StatCard({ title, value, icon, Icon, color = 'blue', trend, subtitle }) {
  const c = COLOR_MAP[color] || COLOR_MAP.blue;
  const trendIsPositive = trend && parseFloat(trend) > 0;
  const trendIsNegative = trend && parseFloat(trend) < 0;

  return (
    <div style={{
      backgroundColor: c.bg, border: `1px solid ${c.border}`, borderRadius: '12px',
      padding: '20px', display: 'flex', alignItems: 'flex-start', gap: '16px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.05)', flex: 1, minWidth: '180px',
    }}>
      {(icon || Icon) && (
        <div style={{
          width: '48px', height: '48px', borderRadius: '10px',
          backgroundColor: 'white', display: 'flex', alignItems: 'center',
          justifyContent: 'center', flexShrink: 0, boxShadow: `0 2px 4px ${c.border}`,
          color: c.icon,
        }}>
          {Icon ? <Icon /> : <span style={{ fontSize: '1.6rem', lineHeight: 1 }}>{icon}</span>}
        </div>
      )}
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '0.82rem', color: c.title, fontWeight: 600, marginBottom: '4px' }}>{title}</div>
        <div style={{ fontSize: '2rem', fontWeight: 800, color: c.value, lineHeight: 1.1 }}>
          {value !== null && value !== undefined ? value : '—'}
        </div>
        {subtitle && <div style={{ fontSize: '0.78rem', color: '#64748b', marginTop: '2px' }}>{subtitle}</div>}
        {trend !== undefined && trend !== null && (
          <div style={{ fontSize: '0.8rem', marginTop: '4px', fontWeight: 600, color: trendIsPositive ? '#16a34a' : trendIsNegative ? '#dc2626' : '#64748b' }}>
            {trendIsPositive ? '↑' : trendIsNegative ? '↓' : '→'} {trend}
          </div>
        )}
      </div>
    </div>
  );
}
